import React, { useRef, useState } from "react";
import { uploadLocationImage, deleteLocationImage } from "services/locationService";

const MAX_SIZE = 5 * 1024 * 1024; // 5 MB
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp"];

const LocationImageUploader = ({ locationId, imageUrl, onImageChange, onClickImage }) => {
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      alert("Format non supporté. Utilisez JPEG, PNG ou WebP.");
      return;
    }
    if (file.size > MAX_SIZE) {
      alert("Fichier trop volumineux (max 5 Mo).");
      return;
    }

    setLoading(true);
    try {
      const url = await uploadLocationImage(locationId, file);
      onImageChange(url);
    } catch (err) {
      console.error("Upload failed:", err);
      alert("Erreur lors de l'upload de l'image.");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  const handleRemove = async () => {
    setLoading(true);
    try {
      await deleteLocationImage(locationId, imageUrl);
      onImageChange(null);
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Erreur lors de la suppression de l'image.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full h-40 rounded-lg bg-slate-800 flex items-center justify-center">
        <svg className="animate-spin h-8 w-8 text-slate-400" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      </div>
    );
  }

  if (imageUrl?.trim()) {
    return (
      <div className="relative group">
        <img
          src={imageUrl}
          alt=""
          className="w-full h-40 object-cover rounded-lg cursor-pointer"
          onClick={onClickImage}
        />
        <button
          onClick={handleRemove}
          className="absolute top-2 right-2 bg-black/60 hover:bg-red-600 text-white rounded-full w-7 h-7 flex items-center justify-center text-sm opacity-0 group-hover:opacity-100 transition-opacity"
          title="Supprimer l'image"
        >
          X
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={() => fileInputRef.current?.click()}
      className="w-full h-32 rounded-lg border-2 border-dashed border-slate-600 hover:border-slate-400 flex flex-col items-center justify-center text-slate-400 hover:text-slate-300 transition-colors cursor-pointer"
    >
      <svg className="w-8 h-8 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <span className="text-sm">Ajouter une image</span>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        className="hidden"
        onChange={handleFileSelect}
      />
    </button>
  );
};

export default LocationImageUploader;
